import type {
  ColumnActionOptions,
  ColumnSizingOptions,
} from '~shared/ui/dashboard-table';

import { ColumnId } from './columns';

export const colSizingOptions: Record<ColumnId, ColumnSizingOptions> = {
  [ColumnId.MERCHANT_NAME]: { minWidth: 160 },
  [ColumnId.POS_NAME]: { minWidth: 160 },
  [ColumnId.LOANS_COUNT]: { width: 160 },
  [ColumnId.LOANS_AMOUNT]: { width: 240 },
  [ColumnId.SALES_AMOUNT]: { width: 240 },
};

export const colActionOptions: Record<ColumnId, ColumnActionOptions> = {
  [ColumnId.MERCHANT_NAME]: { isSortable: false },
  [ColumnId.POS_NAME]: { isSortable: false },
  [ColumnId.LOANS_AMOUNT]: { isSortable: true },
  [ColumnId.LOANS_COUNT]: { isSortable: true },
  [ColumnId.SALES_AMOUNT]: { isSortable: true },
};
